import { WebLinkProps } from '../WebLink/WebLink';
interface MediaGalleryItemTracking {
  fullScreenCarouselView: {
    schema: string;
    data: {
      event_name: string;
      property_id: string;
      media: {
        url: string;
        index: number;
        type: string;
      };
    };
  };
}

export interface MediaShowcaseV2ListingItem {
  __typename?: 'PropertyPage_MediaShowcaseV2_ListingItem';
  key: string;
  image: ListingMediaImage;
  searchByImageButton?: WebLinkProps | null;
}

export interface MediaShowcaseV2AerialItem {
  __typename?: 'PropertyPage_MediaShowcaseV2_AerialItem';
  key: string;
  image: AerialImage;
}

export interface MediaItemV2 {
  key: string;
  image: ListingMediaImage | AerialImage;
  tracking: MediaGalleryItemTracking;
  searchByImageButton?: WebLinkProps | null;
}

export interface ListingMediaImage {
  __typename?: 'PropertyPage_ListingImage';
  alt: string;
  caption?: string | null;
  captionV2?: string | null;
  mobileFullScreenImageJpgUri: string;
  mobileFullScreenImageWebpUri: string;
  desktopFullScreenImageJpgUri: string;
  desktopFullScreenImageWebpUri: string;
}

export interface AerialImage {
  __typename?: 'PropertyPage_AerialImage';
  alt: string;
  caption?: string | null;
  captionV2?: string | null;
  uri: string;
}

export const isAerialImage = (image: ListingMediaImage | AerialImage): image is AerialImage => {
  return '__typename' in image && image.__typename === 'PropertyPage_AerialImage';
};
